// Setup › Tags at `/c/{slug}/setup/tags` (WOS-BUNDLE; core, managers): features/settings.
import { createRoute } from "@tanstack/react-router";
import { TagsScreen } from "../features/settings/tags-screen";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupTagsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "tags",
  component: function Tags() {
    const { api } = setupTagsRoute.useRouteContext();
    return <TagsScreen api={api} company={useCompany()} />;
  },
});
